'use strict';

class ReportsSystemStatusController {
  constructor($scope,
              $q,
              $filter,
              $state,
              utils,
              ReportsService,
              PermissionsService) {
    const $t = $filter('translate');

    const CURRENT_ORG_LOCAL_STORAGE_KEY = 'Organizations-Current';
    $scope.orgInfo = utils.getStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY);
    $scope.accessGlobalStatus = PermissionsService.canIUseGlobalSystemStatus();
    $scope.globalStatus = false;

    $scope.searchVal = '';
    $scope.loading = true;
    $scope.isError = false;

    $scope.tabs = [
      {
        id: 'pulses',
        name: $t('reports.systemStatus.tabs.pulses'),
        icon: 'far fa-heartbeat'
      },
      {
        id: 'min5Statuses',
        name: $t('reports.systemStatus.tabs.min5Statuses'),
        icon: 'far fa-clock',
      },
      {
        id: 'hourStatuses',
        name: $t('reports.systemStatus.tabs.hourStatuses'),
        icon: 'far fa-calendar'
      }
    ];
    $scope.activeTab = 'pulses';

    const config = [
      {
        id: 'botTotal',
        title: $t('reports.systemStatus.sections.botTotal'),
        icon: 'fa-robot'
      },
      {
        id: 'bots',
        title: $t('reports.systemStatus.sections.bots'),
        icon: 'fa-robot'
      },
      {
        id: 'srv',
        title: $t('reports.systemStatus.sections.srv'),
        icon: 'fa-server'
      },
      {
        id: 'c2c',
        title: $t('reports.systemStatus.sections.c2c'),
        icon: 'fa-cloud'
      },
      { id: 'AG', title: $t('reports.systemStatus.sections.AG') },
      { id: 'AM', title: $t('reports.systemStatus.sections.AM') },
      { id: 'APN', title: $t('reports.systemStatus.sections.APN') },
      { id: 'FCM', title: $t('reports.systemStatus.sections.FCM') },
      { id: 'PM', title: $t('reports.systemStatus.sections.PM') },
      { id: 'RS', title: $t('reports.systemStatus.sections.RS') },
      { id: 'S1', title: $t('reports.systemStatus.sections.S1') },
      { id: 'SC', title: $t('reports.systemStatus.sections.SC') },
      { id: 'S3', title: $t('reports.systemStatus.sections.S3') },
      { id: 'S3D', title: $t('reports.systemStatus.sections.S3D') },
      { id: 'SMS', title: $t('reports.systemStatus.sections.SMS') },
      { id: 'ZD', title: $t('reports.systemStatus.sections.ZD') },
    ];
    const DEFAULT_ICON = 'fa-heart-rate';

    angular.extend($scope, {
      toggleGlobalStatus: toggleGlobalStatus,
    });

    init();

    function init() {
      let orgId = $scope.globalStatus ? void 0 : $scope.orgInfo?.id;
      $scope.loading = true;
      $scope.noData = false;
      $scope.isError = false;
      $scope.pulses = undefined;
      $scope.hourlyStatuses = undefined;
      $scope.dailyStatuses = undefined;

      return ReportsService.getSystemStatus(orgId)
        .then((data) => {
          processStatus(data);
          $scope.loading = false;
        }, (err) => {
          utils.handleApiError(err);
          $scope.loading = false;
          $scope.isError = true;
        });
    }

    function processStatus(data) {
      if (!data || (!data.pulses && !data.hourStatuses && !data.min5Statuses)) {
        $scope.noData = true;
      }
      $scope.pulses = processPulseData(data?.pulses);
      $scope.hourlyStatuses = processStatusesData(data?.min5Statuses);
      $scope.dailyStatuses = processStatusesData(data?.hourStatuses);
    }

    function processPulseData(data) {
      if (!data || data.length === 0) {
        return;
      }
      return data
        .map(pulse => {
          if (pulse.type != null) {
            pulse.typeName = $t('reports.systemStatus.types.' + pulse.type);
          }
          pulse.title = [pulse.typeName, pulse.name].filter(e => !!e).join(' - ') || pulse.type;

          if (pulse.time != null) {
            pulse.timeFormatted = moment.duration(pulse.time).format();
          }

          return pulse;
        });
    }

    function processStatusesData(data) {
      if (!data || data.length === 0) {
        return;
      }

      const sections = [];

      data.forEach(record => {
        const time = record.timeMs;

        Object.keys(record)
          .forEach(key => {
            const field = record[key];
            let section = sections.find(s => s.id === key);

            if (angular.isArray(field) && field.every(e => angular.isObject(e))) {
              if (!section) {
                const cfg = config.find(conf => conf.id === key);
                section = {
                  id: key,
                  name: cfg?.title || key,
                  icon: cfg?.icon || DEFAULT_ICON,
                  children: []
                };
                sections.push(section);
              }

              field.forEach(e => {
                let child = section.children.find(ch => ch.id === (e.name || e.id));
                if (!child) {
                  const cfg = config.find(conf => conf.id === e.name);
                  child = {
                    id: e.name || e.id,
                    name: cfg?.title || e.name || e.id,
                    icon: cfg?.icon,
                    description: e.id, // for bots
                    success: 0,
                    errors: 0,
                    history: []
                  };
                  section.children.push(child);
                }
                child.success += e.success || 0;
                child.errors += e.errors || 0;
                child.history.push({
                  success: e.success || 0,
                  errors: e.errors || 0,
                  time: time,
                });
              });

            }
          });
      });

      const dates = data.map(e => e.timeMs);

      sections.forEach(section => {
        section.children.forEach(c => {

          dates.forEach(date => {
            if (!c.history.some(h => h.time === date)) {
              c.history.push({
                empty: true,
                success: 0,
                errors: 0,
                time: date,
              });
            }
          });
          c.history = c.history.sort((a, b) => a.time - b.time);

          const rawPercent = (100 * c.success / (c.success + c.errors));
          if (rawPercent > 99.4) {
            c.percent = Math.floor(100 * c.success / (c.success + c.errors));
          } else if (rawPercent < 0.5) {
            c.percent = Math.ceil(100 * c.success / (c.success + c.errors));
          } else {
            c.percent = Math.round(rawPercent);
          }
        });
      });

      return sections;
    }

    function toggleGlobalStatus() {
      $scope.globalStatus = !$scope.globalStatus;
      $scope.searchVal = '';

      init();
    }

  }
}

export default angular
  .module('main.reports.status.controller', [])
  .controller('ReportsSystemStatusController', ReportsSystemStatusController)
  .name;
